module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comment-wrapper"
  }, [_c('div', {
    staticClass: "smart-button",
    on: {
      "click": _vm.onWriteComment
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../images/community/edit.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.isAnswer ? '添加回答' : '添加评论'))])]), _vm._v(" "), _c('div', {
    staticClass: "all-answer"
  }, [_c('p', [_vm._v("\n            " + _vm._s('全部' + (_vm.isAnswer ? '回答' : '评论') + ' ( ') + "\n            "), _c('span', {
    staticClass: "answer-num"
  }, [_vm._v(_vm._s(_vm.commentListCount))]), _vm._v("\n            " + _vm._s(' )') + "\n        ")]), _vm._v(" "), _c('ul', {
    staticClass: "sort-list"
  }, _vm._l((_vm.sortList), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        'active': _vm.sortType === item.sort
      },
      on: {
        "click": function($event) {
          return _vm.onSwitchSort(item)
        }
      }
    }, [_vm._v("\n                " + _vm._s(item.value) + "\n            ")])
  }), 0)]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading && !_vm.totalPage),
      expression: "isLoading && !totalPage"
    }],
    staticClass: "comment-list"
  }, [(_vm.isWriteComment) ? _c('li', {
    staticClass: "comment-item my-comment"
  }, [_c('div', {
    staticClass: "user-avatar"
  }, [(_vm.curUserInfo.avatar.indexOf('?') === 0) ? _c('img', {
    attrs: {
      "src": require("../../images/personal_center/avatar_default.png")
    },
    on: {
      "click": function($event) {
        return _vm.goUserPage(_vm.curUserInfo.user_id)
      }
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.curUserInfo.avatar
    },
    on: {
      "click": function($event) {
        return _vm.goUserPage(_vm.curUserInfo.user_id)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "comment-content"
  }, [_c('p', {
    staticClass: "nick-name"
  }, [_vm._v(_vm._s(_vm.curUserInfo.nick_name))]), _vm._v(" "), _c('change-editor', {
    staticClass: "comment-editor",
    attrs: {
      "domId": "commentEditor",
      "isFullScreen": true,
      "questionValue": _vm.filterXSS(_vm.commentContent)
    },
    on: {
      "onChangeEditor": _vm.onChangeEditor
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "send-msg"
  }, [_c('span', {
    staticClass: "cancel-btn",
    on: {
      "click": function($event) {
        return _vm.onCancelComment(false)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', {
    class: ['comment-btn', {
      'disabled': !_vm.isAllowComment
    }],
    on: {
      "click": _vm.onConfirmComment
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.isAnswer ? '提交回答' : '提交') + "\n                    ")])])], 1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.commentList), function(item, index) {
    return _c('li', {
      key: index,
      class: ("comment-item comment" + (item.id))
    }, [_c('div', {
      staticClass: "user-avatar"
    }, [_c('el-popover', {
      attrs: {
        "popper-class": "user-card",
        "placement": "top",
        "open-delay": 500,
        "width": "400",
        "trigger": "hover"
      },
      on: {
        "show": function($event) {
          _vm.$refs['card' + item.commented_by.id + index][0].getUserInfo()
        }
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "right",
        "margin": "0, padding: 0"
      }
    }, [_c('user-card', {
      ref: ("card" + (item.commented_by.id) + index),
      refInFor: true,
      attrs: {
        "user-id": item.commented_by.id
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "user-avatar",
      attrs: {
        "slot": "reference"
      },
      on: {
        "click": function($event) {
          _vm.visible = !_vm.visible
        }
      },
      slot: "reference"
    }, [(item.commented_by.user_logo.indexOf('?') === 0) ? _c('img', {
      attrs: {
        "src": require("../../images/personal_center/avatar_default.png")
      },
      on: {
        "click": function($event) {
          return _vm.goUserPage(item.commented_by.user_id)
        }
      }
    }) : _c('img', {
      attrs: {
        "src": item.commented_by.user_logo
      },
      on: {
        "click": function($event) {
          return _vm.goUserPage(item.commented_by.user_id)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      class: ['approval', {
        'active': item.is_vote_up
      }],
      on: {
        "click": function($event) {
          return _vm.agreeInfo(item)
        }
      }
    }, [_c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(item.vote_up_num > 99 ? '100+' : item.vote_up_num || '0'))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.is_vote_up ? '已赞' : '赞同'))])])], 1), _vm._v(" "), _c('div', {
      class: ['comment-content', {
        'show-replay': item.replyShow
      }]
    }, [_c('div', {
      staticClass: "user-info"
    }, [_c('div', {
      staticClass: "user-name",
      on: {
        "click": function($event) {
          return _vm.goUserPage(item.commented_by.user_id)
        }
      }
    }, [_c('span', {
      staticClass: "nick-name"
    }, [_vm._v(_vm._s(item.commented_by.nick_name))])]), _vm._v(" "), (item.commented_by.is_official) ? _c('el-tooltip', {
      attrs: {
        "effect": "light",
        "content": "蓝鲸智云官方",
        "placement": "right"
      }
    }, [_c('svg', {
      staticStyle: {
        "width": "20px",
        "height": "20px"
      },
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-lanjingguanfang"
      }
    })])]) : _vm._e(), _vm._v(" "), (item.commented_by.is_vip) ? _c('el-tooltip', {
      attrs: {
        "effect": "light",
        "content": "核心用户",
        "placement": "right"
      }
    }, [_c('span', {
      staticClass: "icon-vipuser"
    })]) : _vm._e(), _vm._v(" "), (item.is_accept) ? _c('span', {
      staticClass: "adopted"
    }, [_vm._v("已采纳")]) : _vm._e(), _vm._v(" "), (_vm.judgmentIsAuthor(item)) ? _c('span', {
      staticClass: "author"
    }, [_vm._v("作者")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      class: ['comment', {
        'comment-height': item.showMore
      }]
    }, [_c('p', {
      staticClass: "comment-value",
      staticStyle: {
        "word-break": "break-word"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.filterXSS(item.comment))
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.getImgUrl($event)
        }
      }
    }), _vm._v(" "), (item.exceed) ? _c('p', {
      class: ['show-more', {
        'put-away': !item.showMore
      }],
      on: {
        "click": function($event) {
          return _vm.getMoreComment(item.id)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.showMore ? '显示更多' : '收起'))]), _vm._v(" "), _c('i', {
      class: [item.showMore ? 'el-icon-arrow-down' : 'el-icon-arrow-up']
    })]) : _vm._e()]), _vm._v(" "), (_vm.fixedCommentId === item.id) ? _c('p', {
      staticClass: "show-more fixed-bottom",
      style: (_vm.getCommentCollapsePos()),
      on: {
        "click": function($event) {
          return _vm.getMoreComment(item.id)
        }
      }
    }, [_vm._v("\n                    收起\n                    "), _c('i', {
      staticClass: "el-icon-arrow-up"
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "comment-footer"
    }, [_c('div', {
      staticClass: "interact"
    }, [_c('p', {
      class: ['reply', {
        'is-disabled': item.commentShowType === 'edit'
      }],
      on: {
        "click": function($event) {
          return _vm.getReplyList(item)
        }
      }
    }, [_c('span', [_vm._v("\n                                " + _vm._s(item.replyShow && item.commentShowType === 'comment' ? '收起回复' : '回复') + "\n                            ")]), _vm._v(" "), _c('span', {
      staticClass: "number"
    }, [_vm._v("\n                                " + _vm._s(' ( ') + "\n                                "), _c('i', [_vm._v(_vm._s(item.comment_num || '0'))]), _vm._v("\n                                " + _vm._s(' )') + "\n                            ")])]), _vm._v(" "), (_vm.detailInfo.myself && _vm.isAnswer) ? _c('p', {
      staticClass: "cancel-adoption",
      on: {
        "click": function($event) {
          return _vm.onSwitchAccept(item)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.is_accept ? '取消采纳' : '采纳回答'))])]) : _vm._e(), _vm._v(" "), (item.is_mine) ? [_c('p', {
      class: ['delete-comment', {
        'is-disabled': item.comment_num || item.replyShow
      }],
      on: {
        "click": function($event) {
          return _vm.deleteComment(item)
        }
      }
    }, [_vm._v("\n                                删除\n                            ")]), _vm._v(" "), _c('p', {
      class: ['edite-comment', {
        'is-disabled': item.comment_num || item.commentShowType === 'comment'
      }],
      on: {
        "click": function($event) {
          return _vm.onEditComment(item)
        }
      }
    }, [_vm._v("\n                                " + _vm._s(item.commentShowType === 'edit' ? '取消编辑' : '编辑') + "\n                            ")])] : _vm._e()], 2), _vm._v(" "), _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.created_on))])]), _vm._v(" "), (item.replyShow) ? _c('ul', {
      staticClass: "reply-list"
    }, [_c('li', {
      staticClass: "comment-reply"
    }, [(!item.isShowEditor) ? _c('div', {
      staticClass: "input-div"
    }, [(_vm.curUserInfo.avatar.indexOf('?') === 0) ? _c('img', {
      attrs: {
        "width": "30",
        "height": "30",
        "src": require("../../images/personal_center/avatar_default.png")
      },
      on: {
        "click": function($event) {
          return _vm.goUserPage(_vm.curUserInfo.user_id)
        }
      }
    }) : _c('img', {
      attrs: {
        "width": "30",
        "height": "30",
        "src": _vm.curUserInfo.avatar
      },
      on: {
        "click": function($event) {
          return _vm.goUserPage(_vm.curUserInfo.user_id)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "input",
      on: {
        "click": function($event) {
          item.isShowEditor = true
        }
      }
    }, [_vm._v("点击发表评论")])]) : _c('reply', {
      attrs: {
        "replyInfo": item,
        "userInfo": _vm.curUserInfo,
        "isAnswer": _vm.isAnswer
      },
      on: {
        "onChangeEditor": _vm.onChangeEditor,
        "replyComment": _vm.replyComment,
        "onCancelComment": _vm.onCancelComment
      }
    })], 1), _vm._v(" "), (item.commentShowType !== 'edit') ? _vm._l((_vm.replyList[item.id]), function(reply, index) {
      return _c('li', {
        key: index,
        class: [("reply-item comment" + (reply.id))]
      }, [_c('div', {
        staticClass: "reply-box"
      }, [_c('el-popover', {
        attrs: {
          "popper-class": "user-card",
          "placement": "top",
          "open-delay": 500,
          "width": "400",
          "trigger": "hover"
        },
        on: {
          "show": function($event) {
            _vm.$refs['card-child' + reply.commented_by.user_id + index][0].getUserInfo()
          }
        }
      }, [_c('div', {
        staticStyle: {
          "text-align": "right",
          "margin": "0, padding: 0"
        }
      }, [_c('user-card', {
        ref: ("card-child" + (reply.commented_by.user_id) + index),
        refInFor: true,
        attrs: {
          "user-id": reply.commented_by.user_id
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "user-avatar",
        attrs: {
          "slot": "reference"
        },
        slot: "reference"
      }, [_c('div', {
        staticClass: "reply-user-avatar"
      }, [(reply.commented_by.user_logo.indexOf('?') === 0) ? _c('img', {
        attrs: {
          "width": "30",
          "height": "30",
          "src": require("../../images/personal_center/avatar_default.png")
        },
        on: {
          "click": function($event) {
            return _vm.goUserPage(reply.commented_by.user_id)
          }
        }
      }) : _c('img', {
        attrs: {
          "width": "30",
          "height": "30",
          "src": reply.commented_by.user_logo
        },
        on: {
          "click": function($event) {
            return _vm.goUserPage(reply.commented_by.user_id)
          }
        }
      })])])]), _vm._v(" "), _c('div', {
        staticClass: "reply-content"
      }, [_c('div', {
        staticClass: "user-info"
      }, [_c('span', {
        staticClass: "user-name ellipsis",
        on: {
          "click": function($event) {
            return _vm.goUserPage(reply.commented_by.user_id)
          }
        }
      }, [_vm._v(_vm._s(reply.commented_by.nick_name))]), _vm._v(" "), (reply.commented_by.is_official) ? _c('el-tooltip', {
        attrs: {
          "effect": "light",
          "content": "蓝鲸智云官方",
          "placement": "right"
        }
      }, [_c('svg', {
        staticStyle: {
          "width": "20px",
          "height": "20px"
        },
        attrs: {
          "aria-hidden": "true"
        }
      }, [_c('use', {
        attrs: {
          "xlink:href": "#icon-lanjingguanfang"
        }
      })])]) : _vm._e(), _vm._v(" "), (reply.commented_by.is_vip) ? _c('el-tooltip', {
        attrs: {
          "effect": "light",
          "content": "核心用户",
          "placement": "right"
        }
      }, [_c('span', {
        staticClass: "icon-vipuser"
      })]) : _vm._e(), _vm._v(" "), (item.commented_by.user_id === reply.commented_by.user_id) ? _c('span', {
        staticClass: "author"
      }, [_vm._v("\n                                            " + _vm._s(_vm.judgmentIsAuthor(item) ? '作者' : '楼主') + "\n                                        ")]) : _vm._e(), _vm._v(" "), (reply.to) ? [_c('span', {
        staticClass: "gray"
      }, [_vm._v("回复")]), _vm._v(" "), _c('span', {
        staticClass: "user-name ellipsis",
        on: {
          "click": function($event) {
            return _vm.goUserPage(reply.to.commented_by.id)
          }
        }
      }, [_vm._v(_vm._s(reply.to.commented_by.nick_name))]), _vm._v(" "), (reply.to.commented_by.is_official) ? _c('el-tooltip', {
        attrs: {
          "effect": "light",
          "content": "蓝鲸智云官方",
          "placement": "right"
        }
      }, [_c('svg', {
        staticStyle: {
          "width": "20px",
          "height": "20px"
        },
        attrs: {
          "aria-hidden": "true"
        }
      }, [_c('use', {
        attrs: {
          "xlink:href": "#icon-lanjingguanfang"
        }
      })])]) : _vm._e(), _vm._v(" "), (reply.to.commented_by.is_vip) ? _c('el-tooltip', {
        attrs: {
          "effect": "light",
          "content": "核心用户",
          "placement": "right"
        }
      }, [_c('span', {
        staticClass: "icon-vipuser"
      })]) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "gray"
      }, [_vm._v("的回答")]), _vm._v(" "), _c('p', {
        class: ("hidden-text-" + (reply.id)),
        staticStyle: {
          "display": "none"
        },
        domProps: {
          "innerHTML": _vm._s(_vm.filterXSS(reply.to.comment))
        }
      }), _vm._v(" "), _c('p', {
        staticClass: "gray title",
        on: {
          "mouseenter": function($event) {
            return _vm.handlerMouseEnter(reply)
          },
          "mouseleave": function($event) {
            return _vm.handlerMouseLeave(reply)
          },
          "click": function($event) {
            return _vm.scrollIntoReply(reply)
          }
        }
      }, [_vm._v("\n                                                “ "), _c('span', {
        staticClass: "text ellipsis",
        domProps: {
          "innerHTML": _vm._s(_vm.filterXSS(reply.toCommentText))
        }
      }), _vm._v(" ”\n                                            ")])] : _vm._e()], 2), _vm._v(" "), _c('div', {
        class: ['comment', {
          'active': reply.isActive,
          'comment-height': reply.showMore
        }]
      }, [_c('p', {
        staticClass: "reply-value",
        staticStyle: {
          "word-break": "break-word"
        },
        domProps: {
          "innerHTML": _vm._s(_vm.filterXSS(reply.comment))
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.getImgUrl($event)
          }
        }
      }), _vm._v(" "), (_vm.fixedCommentId === reply.id) ? _c('p', {
        staticClass: "put-away fixed-bottom",
        style: (_vm.getCommentCollapsePos()),
        on: {
          "click": function($event) {
            return _vm.getMoreComment(item.id, reply.id)
          }
        }
      }, [_vm._v("\n                                            收起\n                                            "), _c('i', {
        staticClass: "el-icon-arrow-up"
      })]) : _vm._e()]), _vm._v(" "), _c('div', {
        class: ['reply-footer', {
          'active': reply.isActive
        }]
      }, [_c('p', {
        staticClass: "footer-left"
      }, [_c('span', {
        class: ['reply', {
          'is-disabled': reply.replyShowType === 'edit'
        }],
        on: {
          "click": function($event) {
            return _vm.onCommentReply(reply)
          }
        }
      }, [_vm._v("\n                                                " + _vm._s(reply.isCommentReply && reply.replyShowType === 'comment' ? '收起回复' : '回复') + "\n                                            ")]), _vm._v(" "), (reply.is_mine) ? [_c('span', {
        class: ['delete', {
          'is-disabled': reply.isQuote || reply.isCommentReply
        }],
        on: {
          "click": function($event) {
            return _vm.deleteReply(reply)
          }
        }
      }, [_vm._v("\n                                                    删除\n                                                ")]), _vm._v(" "), _c('span', {
        class: ['edite', {
          'is-disabled': reply.isQuote || reply.replyShowType === 'comment'
        }],
        on: {
          "click": function($event) {
            return _vm.onEditReply(reply)
          }
        }
      }, [_vm._v("\n                                                    " + _vm._s(reply.replyShowType === 'edit' ? '取消编辑' : '编辑') + "\n                                                ")])] : _vm._e()], 2), _vm._v(" "), _c('span', {
        staticClass: "time"
      }, [_vm._v(_vm._s(reply.created_on))])]), _vm._v(" "), (reply.exceed) ? _c('p', {
        class: ['show-more', {
          'put-away': !reply.showMore
        }],
        on: {
          "click": function($event) {
            return _vm.getMoreComment(item.id, reply.id)
          }
        }
      }, [_c('span', [_vm._v(_vm._s(reply.showMore ? '显示更多' : '收起'))]), _vm._v(" "), _c('i', {
        class: [reply.showMore ? 'el-icon-arrow-down' : 'el-icon-arrow-up']
      })]) : _vm._e()])], 1), _vm._v(" "), (reply.isCommentReply) ? _c('reply', {
        attrs: {
          "replyInfo": reply,
          "userInfo": _vm.curUserInfo,
          "isAnswer": _vm.isAnswer,
          "isShow": reply.isAnimation
        },
        on: {
          "onChangeEditor": _vm.onChangeEditor,
          "replyComment": _vm.replyComment,
          "onCancelComment": _vm.onCancelComment
        }
      }) : _vm._e()], 1)
    }) : _vm._e(), _vm._v(" "), _c('loading', {
      staticStyle: {
        "padding": "36px 0",
        "background-color": "#ffffff",
        "margin": "0"
      },
      attrs: {
        "ifLoadingStart": item.comment_num && item.replyLoading
      }
    })], 2) : _vm._e()])])
  }), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.commentListCount > 10 && _vm.commentList.length < _vm.commentListCount),
      expression: "commentListCount > 10 && commentList.length < commentListCount"
    }],
    staticClass: "load-more",
    on: {
      "click": function($event) {
        return _vm.doLoadMore()
      }
    }
  }, [(_vm.isLoading) ? _c('img', {
    attrs: {
      "alt": "loadding",
      "src": require("../../images/common/loading_2_24x24.gif")
    }
  }) : _c('p', [_vm._v("加载更多")])]), _vm._v(" "), (_vm.commentListCount === 0 && !_vm.isWriteComment && !_vm.isLoading) ? _c('li', {
    staticClass: "left-attention-null"
  }, [_c('img', {
    attrs: {
      "src": require("../../images/developer/null.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂无评论，点击\n                "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onWriteComment
    }
  }, [_vm._v("抢沙发")])])]) : _vm._e()], 2), _vm._v(" "), (_vm.isFixed) ? _c('section', {
    staticClass: "fixed"
  }, [_c('div', {
    staticClass: "content-footer",
    style: (_vm.getCommentCollapsePos())
  }, [_c('div', {
    staticClass: "btn-wrap"
  }, [_c('p', {
    staticClass: "smart-button",
    on: {
      "click": _vm.onWriteComment
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../images/community/edit.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.isAnswer ? '添加回答' : '添加评论'))])]), _vm._v(" "), (_vm.isAnswer) ? _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "popper-class": "follow-tip",
      "content": _vm.detailInfo.is_followed ? '取消关注' : '关注',
      "placement": "top"
    }
  }, [_c('p', {
    class: ['smart-button follow', {
      'is-followed': _vm.detailInfo.is_followed
    }],
    on: {
      "click": function($event) {
        return _vm.$emit('focusToggle')
      }
    }
  }, [_c('i', {
    staticClass: "img-icon"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detailInfo.is_followed ? '已关注' : '关注'))])])]) : _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "popper-class": "follow-tip",
      "content": _vm.detailInfo.is_liked ? '取消收藏' : '收藏',
      "placement": "top"
    }
  }, [_c('p', {
    class: ['smart-button favorite', {
      'is-favorite': _vm.detailInfo.is_liked
    }],
    on: {
      "click": function($event) {
        return _vm.$emit('favoriteToggle', _vm.detailInfo)
      }
    }
  }, [_c('i', {
    staticClass: "img-icon"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detailInfo.is_liked ? '已收藏' : '收藏'))])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "go-comment",
    on: {
      "click": _vm.scrollIntoComment
    }
  }, [_c('span', [_vm._v(_vm._s('查看所有 ' + _vm.commentListCount + (_vm.isAnswer ? '个回答' : '个评论')))]), _vm._v(" "), _vm._m(0)])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "circle"
  }, [_c('i', {
    staticClass: "el-icon-caret-bottom"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-0f0ad66d!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/community/comment.vue
// module id = 382s
// module chunks = 12